import { Controller } from "stimulus"

export default class extends Controller {

  static targets = [ "button" ]

  disableButton(e) {
    console.log('cliqy')
    let button = e.currentTarget

    if (!button.classList.contains('disabled')) {
      // setTimeout(() => {
        button.classList.add("clicked")
        button.disabled = true
      // }, 0)
    }

  }

}